import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    CREATE_QUALIFICATION, CREATE_QUALIFICATION_ERROR, CREATE_QUALIFICATION_SUCCESS,
    DELETE_QUALIFICATION, DELETE_QUALIFICATION_ERROR, DELETE_QUALIFICATION_SUCCESS,
    FETCH_QUALIFICATION_BY_ID, FETCH_QUALIFICATION_BY_ID_ERROR, FETCH_QUALIFICATION_BY_ID_SUCCESS,
    FETCH_QUALIFICATIONS, FETCH_QUALIFICATIONS_ERROR, FETCH_QUALIFICATIONS_SUCCESS,
    QualificationActionTypes,
    RESTORE_QUALIFICATION, RESTORE_QUALIFICATION_ERROR, RESTORE_QUALIFICATION_SUCCESS,
    UPDATE_QUALIFICATION, UPDATE_QUALIFICATION_ERROR, UPDATE_QUALIFICATION_SUCCESS
} from "../../actions/qualifications/QualificationActions";
import {Qualification} from "../../models/qualifications/Qualification";
import {BasicReducerState, initialReducerState} from "../BasicReducerState";

export interface QualificationState extends BasicReducerState< Nullable< Qualification[] >, Nullable< Qualification > > {

}


const initialState: QualificationState = initialReducerState();

/**
 * PROJECT ROLES REDUCER
 *
 * @see ProjectRoleActionTypes
 * @see ProjectRoleModule
 */
export function QualificationReducer(
    state: QualificationState = initialState,
    action: QualificationActionTypes
) {

    switch( action.type ) {
        case FETCH_QUALIFICATIONS:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: startFetchingRequestState()
                },
            };
        case FETCH_QUALIFICATIONS_SUCCESS:
            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                entries: {
                    current: action.payload.entries,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_QUALIFICATIONS_ERROR:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: errorFetchingRequestState( action.error )
                }
            };
        case FETCH_QUALIFICATION_BY_ID:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.qualificationId.rawValue ]: {
                        entry: null,
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_QUALIFICATION_BY_ID_SUCCESS:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.qualification.qualificationId.rawValue ]: {
                        entry: action.qualification,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_QUALIFICATION_BY_ID_ERROR:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.qualificationId.rawValue ]: {
                        ...state.detailedEntries[ action.qualificationId.rawValue ],
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case CREATE_QUALIFICATION:
        case UPDATE_QUALIFICATION:
        case DELETE_QUALIFICATION:
        case RESTORE_QUALIFICATION:
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        case CREATE_QUALIFICATION_SUCCESS:
        case UPDATE_QUALIFICATION_SUCCESS:
        case DELETE_QUALIFICATION_SUCCESS:
        case RESTORE_QUALIFICATION_SUCCESS:
            return {
                ...state,
                changingRequest: successFetchingRequestState()
            };
        case CREATE_QUALIFICATION_ERROR:
        case UPDATE_QUALIFICATION_ERROR:
        case DELETE_QUALIFICATION_ERROR:
        case RESTORE_QUALIFICATION_ERROR:
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            };
        default:
            return state;
    }

}